import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import type { SerializedStepState } from '../../types';

export function useResetLegacyStepMedia() {
	const track = useTracking();

	const resetStepMedia = useCallback(
		(currentStepState: SerializedStepState | undefined) => {
			if (currentStepState?.petition?.media && currentStepState.petition.media.url === undefined) {
				const updatedStepState = {
					...currentStepState,
					petition: {
						...currentStepState.petition,
						media: null,
					},
				};
				void track('sap_legacy_step_media_reset');

				return updatedStepState;
			}
			return currentStepState;
		},
		[track],
	);

	return resetStepMedia;
}
